import { createStore, type StoreConfig } from './state-helper'

export type Locale = {
  locale: string
  language: string
  country: string
}

type LocaleStore = {
  locale: Locale
  setLocale: (cart: Partial<Locale>) => void
}

const createInitial = () => ({
  locale: '',
  language: '',
  country: '',
})

const getSetLocale: StoreConfig<LocaleStore> = (set, get) => ({
  locale: createInitial(),
  setLocale: (locale: Partial<Locale>) => {
    const updated = { ...get().locale, ...locale }
    set({ locale: updated })
  },
})

export const useLocaleStore = createStore(getSetLocale, {
  name: 'locale_storage',
})
